import { Tag } from 'antd'
import styled from 'styled-components'

export const TagStyled = styled(Tag)`
  margin-right: 0px;
  max-width: 100%;
  white-space: break-spaces;
  word-break: break-all;
`
